export default __webpack_public_path__ + "static/media/paris.e0911362.png";